/**
 * Where the shown company is, for its address line and the shareholder graph's target card, so
 * both read the same place: the company record first, then its details (the details request),
 * then the 'City, Country' headquarters text of a search result.
 *
 * @param {Object} [company] - the shown company (observableCompany)
 * @param {Object} [details] - companyDetails from that company's details response
 * @returns {{city: string|undefined, country: string|undefined}}
 */
export const resolveCompanyLocation = (company, details) => {
  const [headquartersCity, headquartersCountry] =
    typeof company?.headquarters === 'string'
      ? company.headquarters.split(', ').map((part) => part.trim())
      : [];
  return {
    city: company?.city || details?.city || headquartersCity,
    country: company?.country || details?.country || headquartersCountry
  };
};
